module.exports = __webpack_public_path__ + "static/media/full-logo.022e85ea.png";